module.exports = __webpack_public_path__ + "static/media/landscape-crop.f139c849.webp";